export default __webpack_public_path__ + "static/media/group-org5.5e553151.jpg";